import React from "react";
import Header from "../nav/Header";
import {
  Card,
  CardHeader,
  CardTitle,
  CardImage,
  CardSubtitle,
  CardBody,
} from "@progress/kendo-react-layout";

function Ambulance() {
  return (
    <React.Fragment>
      <Header />
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <h1 className="welcome mb-0">Ambulance and Emergency Numbers</h1>
            <h2 className="sub-header mt-0">
                Listings of Emergency contacts. Our in-house mid-wife is available 24/7 to answer your questions
                and guide you.
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <Card>
              <CardImage src="https://images.pexels.com/photos/6753491/pexels-photo-6753491.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260" />
              <div>
                <CardHeader>
                  <CardTitle>National Ambulance Service</CardTitle>
                  <CardSubtitle>
                    <div>030 000 0000</div>
                  </CardSubtitle>
                </CardHeader>
              </div>
            </Card>
          </div>
          <div className="col-4">
            <Card>
              <CardImage src="https://images.pexels.com/photos/40568/medical-appointment-doctor-healthcare-40568.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260" />
              <div>
                <CardHeader>
                  <CardTitle>Jane Doe (In House Midwife)</CardTitle>
                  <CardSubtitle>
                    <div>030 000 0000</div>
                  </CardSubtitle>
                </CardHeader>
              </div>
            </Card>
          </div>
          <div className="col-4">
            <Card>
              <CardImage src="https://images.pexels.com/photos/127873/pexels-photo-127873.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260" />
              <div>
                <CardHeader>
                  <CardTitle>XYZ Hospital (Partners)</CardTitle>
                  <CardSubtitle>
                    <div>030 000 0000</div>
                  </CardSubtitle>
                </CardHeader>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Ambulance;
